module.exports = __webpack_public_path__ + "img/feature_buy_freespin_ko.8afaf4e3.png";